import { sortCustomersByField } from '../../actions';

export const MobileDeliveryDropdownOptions = {
    placeholder: 'סדר מוצרים',
    mainContent: null,
    setDisplayedData: null,
    data: [
        {
            label: 'ע״פ א ב',
            action: null
        }
        // {
        //     label: 'ע״פ סדר נסיעה',
        //     action: null
        // }
    ],
    setup(mainContentRef, setDisplayedDataRef) {
        this.mainContent = mainContentRef;
        this.setDisplayedData = setDisplayedDataRef;
        this.data[0].action = () => {
            const sortedData = sortCustomersByField(this.mainContent, 'name');
            this.setDisplayedData(sortedData);
        };
    }
};
